// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image-container[data-v-3a7ecdfa]{height:100%;width:100%}.image-container__image[data-v-3a7ecdfa]{background-color:var(--body-bg);height:100%;-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center;transition:opacity .3s linear;width:100%}.image-container__image--waiting[data-v-3a7ecdfa]{opacity:0}.image-container__image--contain[data-v-3a7ecdfa]{-o-object-fit:contain;object-fit:contain}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
